export default __webpack_public_path__ + "static/GT-Walsheim-Bold-1bcdcd82e6cd83f0efbdb73adeab7f45.woff2";